import React, { useState, useEffect } from 'react';
import { buildApiUrl } from '../utils/apiUrl';

const placeholderImg = '/defaultimages/imagenotavailable.jpg';

const BuyOrSellGeneral = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [search, setSearch] = useState('');
  const [location, setLocation] = useState('');
  const [category, setCategory] = useState('');
  const [modalItem, setModalItem] = useState(null);
  const [buyOrSell, setBuyOrSell] = useState('');
  
  useEffect(() => {
    const fetchItems = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await fetch(buildApiUrl('/api/buyorsellgeneral'));
        if (!response.ok) {
          throw new Error('Failed to fetch items');
        }
        const data = await response.json();
        setItems(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchItems();
  }, []);

  const handleViewDetails = (item) => {
    setModalItem({
      ...item,
      images: item.photos || [], // Use the photos field for images
      currentImageIndex: 0
    });
  };

  const closeModal = () => {
    setModalItem(null);
  };

  const locationOptions = Array.from(new Set(items.map(item => item.locationname))).filter(Boolean).sort();
  const categoryOptions = Array.from(new Set(items.map(item => item.category))).filter(Boolean).sort();

  const filteredItems = items.filter(item => {
    return (
      (!buyOrSell || item.businesstype === (buyOrSell === 'Buy' ? 'B' : 'S')) && // Filter by businesstype
      (!location || item.locationname === location) &&
      (!category || item.category === category) &&
      (!search || (item.itemname && item.itemname.toLowerCase().includes(search.toLowerCase())))
    );
  });

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div style={{ padding: '5px', fontFamily: 'Arial, sans-serif' }}>


      
       {/* Header */}
      <header style={{ background: '#e8f5e9', color: '#388e3c', padding: '0.25rem', textAlign: 'center', borderRadius: 8, marginBottom: 2 }}>
        <h1 style={{ margin: 0, fontSize: '1.0rem', fontWeight: 700 }}>Buy or Sell (New/Used) </h1>
      </header>

      <div style={{ marginBottom: '10px', display: 'flex', gap: '10px', flexWrap: 'wrap', alignItems: 'center' }}>
        <select value={buyOrSell} onChange={(e) => setBuyOrSell(e.target.value)} style={{ padding: '6px', border: '1px solid #ccc', borderRadius: '4px', height: '32px' }}>
          <option value="">Buy/Sell</option>
          <option value="Buy">Buy</option>
          <option value="Sell">Sell</option>
        </select>
        <select value={location} onChange={(e) => setLocation(e.target.value)} style={{ padding: '6px', border: '1px solid #ccc', borderRadius: '4px', height: '32px' }}>
          <option value="">All Locations</option>
          {locationOptions.map(loc => (
            <option key={loc} value={loc}>{loc}</option>
          ))}
        </select>
        <select value={category} onChange={(e) => setCategory(e.target.value)} style={{ padding: '6px', border: '1px solid #ccc', borderRadius: '4px', height: '32px' }}>
          <option value="">All Categories</option>
          {categoryOptions.map(cat => (
            <option key={cat} value={cat}>{cat}</option>
          ))}
        </select>
        <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
          <input
            type="text"
            placeholder="Search..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{ padding: '4px', border: '1px solid #ccc', borderRadius: '4px', width: '150px', height: '20px' }}
          />
          <button
            onClick={() => {
              setSearch('');
              setLocation('');
              setCategory('');
              setBuyOrSell('');
            }}
            style={{
              position: 'absolute',
              right: '-70px', /* Keep the button at the adjusted position */
              background: 'transparent',
              border: 'none',
              color: '#007BFF',
              cursor: 'pointer',
              fontSize: '12px'
            }}
          >
            Clear All
          </button>

          {search.trim() && items.some(item => item.itemname && item.itemname.toLowerCase().includes(search.toLowerCase())) && (
            <ul style={{
              position: 'absolute',
              top: '32px',
              left: 0,
              background: '#fff',
              border: '1px solid #ccc',
              borderRadius: '4px',
              width: '150px',
              maxHeight: '150px',
              overflowY: 'auto',
              padding: '4px',
              listStyle: 'none',
              margin: 0,
              zIndex: 1000
            }}>
              {items
                .filter(item => item.itemname && item.itemname.toLowerCase().includes(search.toLowerCase()))
                .map(filteredItem => (
                  <li 
                    key={filteredItem.bid} 
                    style={{ padding: '4px', cursor: 'pointer' }}
                    onClick={() => {
                      setSearch(filteredItem.itemname); // Update search field
                      setItems([filteredItem]); // Optionally filter items to the selected one
                    }}
                  >
                    {filteredItem.itemname}
                  </li>
                ))}
            </ul>
          )}
        </div>
      </div>
      <p style={{ fontSize: '10px', color: '#888', marginTop: '4px' }}>
          Total items listed: {filteredItems.length}
        </p>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '4px' }}>
        {filteredItems.map(item => (
          <div key={item.bid} onClick={() => handleViewDetails(item)} style={{ border: '1px solid #ccc', borderRadius: '8px', padding: '10px', cursor: 'pointer' }}>
            <img src={item.imagepath || placeholderImg} alt={item.itemname} style={{ width: '100%', height: '150px', objectFit: 'cover', borderRadius: '4px' }} />
            <h2 style={{ fontSize: '16px', marginBottom: '2px', marginTop: '2px', fontWeight: 'bold' }}>
              {item.title}
            </h2>
            <h2 style={{ fontSize: '12px', marginBottom: '4px', marginTop: '4px' }}>
              {item.itemname} <span style={{ fontSize: '12px', color: '#777' }}>( {item.category} )</span>
            </h2>
            <p style={{ color: '#555', fontSize: '12px', marginBottom: '2px', marginTop: '2px', fontWeight: 600 }}>
              {item.locationname} - {item.areaname}
            </p>
            <p style={{ color: '#555', fontSize: '14px', marginBottom: '6px', marginTop: '4px', overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }}>
              <strong>Description:</strong> {item.aboutdescription || 'No description available.'}
            </p>
            {item.contactperson && (
              <p style={{ color: '#333', fontSize: '13px', marginBottom: '0px' }}>
                <strong>Contact Person:</strong> {item.contactperson}
              </p>
            )}
            {item.contactnumber && (
              <p style={{ color: '#333', fontSize: '13px', marginBottom: '0px', marginTop: '4px' }}>
                <strong>Contact Number:</strong> <a href={`tel:${item.contactnumber}`} style={{ color: '#007BFF', textDecoration: 'none', fontSize: '13px' }}>{item.contactnumber}</a>
              </p>
            )}
          </div>
        ))}
      </div>

      {modalItem && (
        <div
          onClick={closeModal}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0,0,0,0.6)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000,
            padding: 16
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background: '#fff',
              borderRadius: 16,
              maxWidth: 450,
              width: '100%',
              maxHeight: '90vh',
              overflowY: 'auto',
              position: 'relative',
              boxShadow: '0 8px 32px rgba(0,0,0,0.2)'
            }}
          >
            <button
              onClick={closeModal}
              style={{
                position: 'absolute',
                top: 12,
                right: 12,
                background: '#fff',
                color: '#d32f2f',
                border: '2px solid #d32f2f',
                borderRadius: '50%',
                width: 44,
                height: 44,
                cursor: 'pointer',
                fontSize: 28,
                fontWeight: 'bold',
                boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 10,
                transition: 'background 0.2s, color 0.2s, border 0.2s'
              }}
              aria-label="Close"
              onMouseOver={e => {
                e.currentTarget.style.background = '#d32f2f';
                e.currentTarget.style.color = '#fff';
                e.currentTarget.style.border = '2px solid #fff';
              }}
              onMouseOut={e => {
                e.currentTarget.style.background = '#fff';
                e.currentTarget.style.color = '#d32f2f';
                e.currentTarget.style.border = '2px solid #d32f2f';
              }}
            >
              ×
            </button>

            {/* Image Carousel */}
            <div style={{ position: 'relative', textAlign: 'center' }}>
              <button
                aria-label="Previous image"
                onClick={() => setModalItem((prev) => ({ ...prev, currentImageIndex: (prev.currentImageIndex - 1 + prev.images.length) % prev.images.length }))}
                style={{
                  position: 'absolute',
                  top: '50%',
                  left: 10,
                  transform: 'translateY(-50%)',
                  background: '#fff',
                  color: '#1976d2',
                  border: '2px solid #1976d2',
                  borderRadius: '50%',
                  width: 40,
                  height: 40,
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.10)',
                  fontSize: 28,
                  zIndex: 10,
                  transition: 'background 0.2s, color 0.2s, border 0.2s'
                }}
                onMouseOver={e => {
                  e.currentTarget.style.background = '#1976d2';
                  e.currentTarget.style.color = '#fff';
                  e.currentTarget.style.border = '2px solid #fff';
                }}
                onMouseOut={e => {
                  e.currentTarget.style.background = '#fff';
                  e.currentTarget.style.color = '#1976d2';
                  e.currentTarget.style.border = '2px solid #1976d2';
                }}
              >
                <span className="material-icons" style={{ fontSize: 28, lineHeight: 1 }}>chevron_left</span>
              </button>

              <img

                src={modalItem.images[modalItem.currentImageIndex] || placeholderImg}
                alt={modalItem.itemname}
                style={{
                  width: '90%',
                  maxWidth: 400,
                  height: 240,
                  objectFit: 'cover',
                  borderRadius: 12,
                  display: 'block',
                  margin: '12px auto 0 auto'
                }}
                onError={(e) => { e.target.onerror = null; e.target.src = placeholderImg; }}
              />

            {/* Image Preview Thumbnails */}
            {modalItem.images && modalItem.images.length > 1 && (
              <div style={{ display: 'flex', justifyContent: 'center', gap: 8, marginTop: 12, marginBottom: 4 }}>
                {modalItem.images.map((img, idx) => (
                  <img
                    key={img + idx}
                    src={img || placeholderImg}
                    alt={`Preview ${idx + 1}`}
                    style={{
                      width: 48,
                      height: 48,
                      objectFit: 'cover',
                      borderRadius: 6,
                      border: idx === modalItem.currentImageIndex ? '2px solid #1976d2' : '1px solid #ccc',
                      cursor: 'pointer',
                      boxShadow: idx === modalItem.currentImageIndex ? '0 0 6px #1976d2' : 'none',
                      opacity: idx === modalItem.currentImageIndex ? 1 : 0.7
                    }}
                    onClick={() => setModalItem((prev) => ({ ...prev, currentImageIndex: idx }))}
                    onError={(e) => { e.target.onerror = null; e.target.src = placeholderImg; }}
                  />
                ))}
              </div>
            )}

              <button
                aria-label="Next image"
                onClick={() => setModalItem((prev) => ({ ...prev, currentImageIndex: (prev.currentImageIndex + 1) % prev.images.length }))}
                style={{
                  position: 'absolute',
                  top: '50%',
                  right: 10,
                  transform: 'translateY(-50%)',
                  background: '#fff',
                  color: '#1976d2',
                  border: '2px solid #1976d2',
                  borderRadius: '50%',
                  width: 40,
                  height: 40,
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.10)',
                  fontSize: 28,
                  zIndex: 10,
                  transition: 'background 0.2s, color 0.2s, border 0.2s'
                }}
                onMouseOver={e => {
                  e.currentTarget.style.background = '#1976d2';
                  e.currentTarget.style.color = '#fff';
                  e.currentTarget.style.border = '2px solid #fff';
                }}
                onMouseOut={e => {
                  e.currentTarget.style.background = '#fff';
                  e.currentTarget.style.color = '#1976d2';
                  e.currentTarget.style.border = '2px solid #1976d2';
                }}
              >
                <span className="material-icons" style={{ fontSize: 28, lineHeight: 1 }}>chevron_right</span>
              </button>
            </div>

            <div style={{ padding: '8px 20px 20px 20px' }}>
              <h2 style={{ margin: '0 0 8px 0', fontSize: 18, marginBottom: 4, fontWeight: 'bold', color: '#333' }}>
                {modalItem.title}
              </h2>
              <h2 style={{ margin: '0 0 2px 0', fontSize: 14, color: '#1976d2' }}>
                {modalItem.itemname} <span style={{ fontSize: 12, color: '#666' }}>( {modalItem.category} )</span>
              </h2>

              <div style={{ fontSize: 13, color: '#888', marginBottom: 2, fontWeight: 600 }}>
                {modalItem.locationname} - {modalItem.areaname}
              </div>

              <div style={{ marginTop: 4, marginBottom: 4 }}>
                <strong style={{ fontSize: '0.90rem', color: '#333', display: 'inline' }}>Description:</strong>
                <span style={{ marginLeft: 6, color: '#333', lineHeight: 1.4, fontSize: '0.80rem', display: 'inline' }}>{modalItem.aboutdescription}</span>
              </div>

              {modalItem.contactnumber && (
                <div style={{ marginBottom: 6 }}>
                  <strong style={{ fontSize: 15, color: '#333' }}>Contact Details:</strong>
                  <a 
                    href={`tel:${modalItem.contactnumber.replace(/\s/g, '')}`}
                    style={{ 
                      fontSize: 14, 
                      color: '#d32f2f', 
                      marginTop: 4, 
                      fontWeight: 600,
                      textDecoration: 'none',
                      display: 'block',
                      cursor: 'pointer'
                    }}
                  >
                    📞 {modalItem.contactnumber}
                  </a>
                </div>
              )}

              {modalItem.emailid && (
                <div style={{ marginBottom: 2 }}>
                  <strong style={{ fontSize: 12, color: '#333' }}>Email:</strong>
                  <a href={`mailto:${modalItem.emailid}`} style={{ fontSize: 12, color: '#1976d2', textDecoration: 'none', marginLeft: 8 }}>{modalItem.emailid}</a>
                </div>
              )}

              {modalItem.address1 && (
                <div style={{ marginBottom: 12 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                    <strong style={{ fontSize: 12, color: '#333' }}>Address:</strong>
                    <span style={{ fontSize: 12, color: '#666' }}>{modalItem.address1}</span>
                  </div>
                </div>
              )}

              <div style={{ display: 'flex', gap: '10px', marginTop: '8px' }}>
                <button style={{ padding: '6px 12px', backgroundColor: '#007BFF', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer' }} onClick={() => window.location.href = `tel:${modalItem.contactnumber}`}>
                  Call
                </button>
                <div style={{ position: 'relative' }}>
                  <button style={{ padding: '6px 12px', backgroundColor: '#28a745', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer' }} onClick={(e) => {
                    e.stopPropagation();
                    const dropdown = e.currentTarget.nextElementSibling;
                    if (dropdown) {
                      const isVisible = dropdown.style.display === 'block';
                      dropdown.style.display = isVisible ? 'none' : 'block';
                    }
                  }}>
                    Share
                  </button>
                  <ul style={{ position: 'absolute', bottom: '100%', left: 0, background: '#fff', border: '1px solid #ccc', borderRadius: '8px', listStyle: 'none', padding: '8px 0', margin: 0, display: 'none', zIndex: 1000, boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)' }}>
                    <li style={{ padding: '8px 16px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '12px', transition: 'background-color 0.2s', fontSize: '14px', color: '#333', backgroundColor: '#ffffff' }}
                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f5f5f5'}
                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#ffffff'}
                        onClick={() => window.open(`https://wa.me/?text=${encodeURIComponent(modalItem.itemname)}`, '_blank')}>
                      <i className="fab fa-whatsapp"></i>
                      <font color="#25D366" fontSize='14px'>  WhatsApp</font> 
                    </li>
                    <li style={{ padding: '8px 16px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '12px', transition: 'background-color 0.2s', fontSize: '14px', color: '#333', backgroundColor: '#ffffff' }}
                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f5f5f5'}
                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#ffffff'}
                        onClick={() => window.location.href = `mailto:?subject=${encodeURIComponent(modalItem.itemname)}&body=${encodeURIComponent(modalItem.aboutdescription)}`}>
                      <i className="fas fa-envelope"></i>
                      <font color="#D44638" fontSize='14px'>Email</font> 
                    </li>
                    <li style={{ padding: '8px 16px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '12px', transition: 'background-color 0.2s', fontSize: '14px', color: '#333', backgroundColor: '#ffffff' }}
                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f5f5f5'}
                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#ffffff'}
                        onClick={() => navigator.clipboard.writeText(`${modalItem.itemname} - ${modalItem.aboutdescription}`)}>
                      <i className="fas fa-copy"></i>
                      <font color="#007BFF" fontSize='14px'> Copy to</font> 
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BuyOrSellGeneral;
